var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BottomPopup', {
    staticClass: "form-item-bottom-popup",
    attrs: {
      "show": _vm.props.show,
      "title": _vm.props.title,
      "borderRadius": "20px"
    },
    on: {
      "onClose": _vm.onClose,
      "onSubmit": _vm.onSubmit
    }
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }